import { usePageMeta } from '../lib/usePageMeta.js'
import { SITE } from '../lib/site.js'
import { TEAM, VALUES } from '../lib/content.js'
import { CtaBand, IconTile, PageHero, Section, SectionHead } from '../components/ui.jsx'

function Story() {
  return (
    <Section id="story">
      <div className="grid gap-y-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-x-16">
        <SectionHead align="left" eyebrow="Our story" title="Started on a job site, not in a boardroom." />
        <div className="flex flex-col gap-y-5 text-[17px] leading-[1.7] text-dim">
          <p>
            Boss Contractor Agency started after too many conversations with owners who had
            paid a generic agency for a pretty website and a monthly report full of words like
            impressions, and still had an empty calendar in February.
          </p>
          <p>
            We only work with contractors. That means we already know the seasons, the
            service areas, what a storm does to a roofing market, and what a good lead sounds
            like on the phone. It also means we can tell you in the first call, honestly,
            whether marketing is your problem or follow-up is.
          </p>
          <p>
            Everything we build stays in your name, every plan is month to month after the
            first 90 days, and the only number we ask to be judged on is jobs booked.
          </p>
        </div>
      </div>
    </Section>
  )
}

function Values() {
  return (
    <Section id="values" tone="surface">
      <SectionHead eyebrow="How we work" title="Four rules we do not break." />
      <div className="mt-12 grid gap-6 md:grid-cols-2">
        {VALUES.map((v) => (
          <div
            key={v.title}
            className="flex gap-x-5 rounded-[16px] border border-line bg-white p-7 shadow-card"
          >
            <IconTile name={v.icon} />
            <div className="flex flex-col gap-y-2">
              <h3 className="text-[18px] font-bold tracking-[-0.01em] text-ink">{v.title}</h3>
              <p className="text-[15px] leading-[1.6] text-dim">{v.body}</p>
            </div>
          </div>
        ))}
      </div>
    </Section>
  )
}

function Team() {
  return (
    <Section id="team">
      <SectionHead
        eyebrow="The team"
        title="Small on purpose."
        body="You get the people who do the work, not an account manager reading a dashboard."
      />
      <div className="mt-12 grid gap-6 sm:grid-cols-3">
        {TEAM.map((m) => (
          <div
            key={m.name}
            className="flex flex-col items-center gap-y-4 rounded-[16px] border border-line bg-white p-8 text-center shadow-card"
          >
            <span className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-night text-[20px] font-extrabold tracking-[-0.02em] text-white">
              {m.initials}
            </span>
            <div className="flex flex-col gap-y-1">
              <span className="text-[17px] font-bold text-ink">{m.name}</span>
              <span className="text-[14px] text-dim">{m.role}</span>
            </div>
          </div>
        ))}
      </div>
    </Section>
  )
}

export default function About() {
  usePageMeta(
    'About',
    'Boss Contractor Agency only works with contractors. Booked jobs are the metric, you own everything, and every plan is month to month.',
  )
  return (
    <>
      <PageHero
        eyebrow="About"
        title="An agency that only works with contractors."
        body={`${SITE.location} Roofing, HVAC, plumbing, electrical, remodeling and the rest of the trades.`}
      />
      <Story />
      <Values />
      <Team />
      <CtaBand phone={{ href: SITE.phoneHref, label: SITE.phone }} />
    </>
  )
}
